import React from 'react';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import { BtnContainer, KeyWordBtn } from './styles';

import { keyWords } from '../../data';

export function KeyWords({ setKeyWord, keyWord }) {
  return (
    <Box sx={{ marginTop: '30px' }}>
      <Typography component="h6" variant="h3" sx={{ fontWeight: '600' }}>
        Palavras-chave:
      </Typography>
      <BtnContainer>
        {keyWords.map(({ label, value }) => (
          <KeyWordBtn
            onClick={() => setKeyWord(value === keyWord ? '' : value)}
            sx={{
              backgroundColor: value === keyWord && '#1D6FBB',
              color: value === keyWord ? '#FFF' : '#1D6FBB',
              '&:hover': {
                color: '#1D6FBB',
              },
            }}
          >
            {label}
          </KeyWordBtn>
        ))}
      </BtnContainer>
    </Box>
  );
}
